import { boolean as yupBoolean, string as yupString, object as yupObject } from 'yup';

export type FormValues = {
  fullName: string;
  email: string;
  company: string;
  wantsCall: boolean;
};

export const defaults = {
  title: 'Download the checklist',
  className: '',
  buttonLabel: 'Download',
};

export const CALENDLY_BOOKING_URL = 'https://calendly.com/sgladun/30min';

export const config = {
  initialValues: {
    fullName: '',
    email: '',
    company: '',
    wantsCall: false,
  },
  validationSchema: yupObject({
    fullName: yupString().default('').required('Please enter your full name'),
    email: yupString()
      .default('')
      .required('Please enter your email address')
      .email('Please enter a valid email address'),
    company: yupString().default(''),
    wantsCall: yupBoolean().default(false),
  }),
  isInitialValid: false,
  validateOnBlur: false,
};
